import { Box, Button, Grid2, Stack } from "@mui/material";
import { actionToAppMainPageUtils, IActionToAppMainPage } from "./IToAppMainPage.intf";
import { childToProjectDataUtils, IChildToProjectData } from "../../../utils";
import { useRouter } from "next/router";
import { IActionOrTriggerListPageParams, ActionOrTriggerListTypeEnum } from "@app/static";
import { useProxyWatch, useTranslation } from "@fanfanlo";
export function UI(data: IActionToAppMainPage) {
    const { t } = useTranslation("droid-project-interface/actions/app/to-app-main-page/content")
    const router = useRouter()
    const backPath = router.pathname;
    const [pn] = useProxyWatch(data, "javaData.pn", data.javaData.pn)
    const [an] = useProxyWatch(data, "javaData.an", data.javaData.an)
    function onChangeClick() {
        const projectInfo: IChildToProjectData = {}
        childToProjectDataUtils.actionList.getActionListByProp(data, projectInfo)
        if (!projectInfo.project?.id || !projectInfo.triggerActionGroup?.id || !projectInfo.triggerAction?.id || !projectInfo.actionGroup?.id) {
            console.error('UpdateAppLink projectInfo is undefined', projectInfo)
            return
        }

        const query: IActionOrTriggerListPageParams = {
            backPath,
            projectId: projectInfo.project?.id,
            triggerActionGroupId: projectInfo.triggerActionGroup?.id,
            triggerActionId: projectInfo.triggerAction?.id,
            actionGroupId: projectInfo.actionGroup?.id,
            type: ActionOrTriggerListTypeEnum.updateAction,
            actionId: data.id,
            actionType: actionToAppMainPageUtils.type,
        }
        actionToAppMainPageUtils.onClickChange?.({ query })
    }
    return (
        <>
            <Box sx={{ width: "100%" }}>
                <Box>
                    <b>{t("content.title")}</b>
                </Box>
                <Grid2 container sx={{ width: "100%" }}>
                    <Grid2 size="grow" container>
                        <Stack direction="column" spacing={2}>
                            <Box>
                                <span>
                                    {t("content.pnName")}
                                </span>
                                <span>
                                    {pn}
                                </span>
                            </Box>
                            <Box>
                                <span>
                                    {t("content.anName")}
                                </span>
                                <span>
                                    {an}
                                </span>
                            </Box>
                        </Stack>
                    </Grid2>
                    <Grid2 size={"auto"}>
                        <Button onClick={onChangeClick}>
                            <span>{t("content.changeBtnLabel")}</span>
                        </Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}